import { Bars3Icon, BellIcon, ArrowPathIcon, EyeIcon, EyeSlashIcon } from '@heroicons/react/24/outline';
import { useRefreshPrices } from '../../hooks/useAssets';
import { useValuesVisibility } from '../../stores/valuesVisibilityStore';

interface TopBarProps {
  onMenuClick: () => void;
}

export function TopBar({ onMenuClick }: TopBarProps) {
  const { mutate: refreshPrices, isPending } = useRefreshPrices();
  const { isVisible, toggle } = useValuesVisibility();

  return (
    <header className="sticky top-0 z-10 bg-surface-900/80 backdrop-blur-sm border-b border-white/5 px-4 md:px-6 lg:px-8">
      <div className="flex items-center justify-between h-16">
        {/* Mobile menu button */}
        <button
          onClick={onMenuClick}
          className="btn-ghost p-2 rounded-lg lg:hidden"
        >
          <Bars3Icon className="h-5 w-5" />
        </button>

        <div className="hidden lg:block" />

        {/* Actions */}
        <div className="flex items-center gap-2">
          <button
            onClick={toggle}
            className="btn-ghost p-2 rounded-lg"
            title={isVisible ? 'Ocultar valores' : 'Exibir valores'}
          >
            {isVisible
              ? <EyeIcon className="h-5 w-5 text-primary-400" />
              : <EyeSlashIcon className="h-5 w-5" />
            }
          </button>
          <button
            onClick={() => refreshPrices()}
            disabled={isPending}
            className="btn-ghost p-2 rounded-lg"
            title="Atualizar preços"
          >
            <ArrowPathIcon
              className={`h-5 w-5 ${isPending ? 'animate-spin text-primary-400' : ''}`}
            />
          </button>
          <button className="btn-ghost p-2 rounded-lg" title="Notificações">
            <BellIcon className="h-5 w-5" />
          </button>
        </div>
      </div>
    </header>
  );
}
